// src/lib/auditClient.ts
const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const API_BASE = isDevelopment
  ? 'http://localhost:3001'   // dev: your Express server
  : '';                        // prod: same origin

console.log('🌐 Audit API environment detection:', {
  hostname: window.location.hostname,
  isDevelopment,
  apiBase: API_BASE || 'same origin'
});

export async function auditLogin(idToken: string, provider: 'password'|'google'|'microsoft') {
  const res = await fetch(`${API_BASE}/api/audit-login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ idToken, provider }),
  });
  let data: any = {};
  try { data = await res.json(); } catch {}
  if (!res.ok || data?.ok === false) {
    console.error('audit-login failed', { status: res.status, data });
    throw new Error(data?.error || `audit-login HTTP ${res.status}`);
  }
}

export async function auditProfileChange(idToken: string, changes: Record<string, { old:any; new:any }>) {
  const res = await fetch(`${API_BASE}/api/audit-profile`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ idToken, changes }),
  });
  let data: any = {};
  try { data = await res.json(); } catch {}
  if (!res.ok || data?.ok === false) {
    console.error('audit-profile failed', { status: res.status, data });
    throw new Error(data?.error || `audit-profile HTTP ${res.status}`);
  }
}
